import React, { useRef, useCallback } from "react";

/**
 * 3D Tactile vertical Fader
 */
export default function Fader({
  value,
  min = 0,
  max = 1,
  height = 140,
  label = "",
  onChange,
  "data-testid": testId,
}) {
  const trackRef = useRef(null);

  const range = max - min;
  const normalized = (value - min) / range;
  const capTop = (1 - normalized) * (height - 22);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    const track = trackRef.current;
    if (!track) return;
    const rect = track.getBoundingClientRect();

    const updateFromY = (clientY) => {
      const y = clientY - rect.top;
      const n = 1 - Math.max(0, Math.min(1, y / rect.height));
      const v = min + n * range;
      onChange(Number(v.toFixed(4)));
    };

    updateFromY(e.clientY);

    const onMove = (ev) => updateFromY(ev.clientY);
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, [min, range, onChange]);

  return (
    <div className="flex flex-col items-center gap-1.5">
      <div
        ref={trackRef}
        className="fader-track"
        style={{ height }}
        onMouseDown={handleMouseDown}
        data-testid={testId}
      >
        <div className="fader-cap" style={{ top: capTop }} />
      </div>
      {label && <div className="label-mono">{label}</div>}
    </div>
  );
}
